import Button from "@src/components/elements/Button";
import { useEffect, useState } from "react";
import useGlobalVariable from "@lib/store/hooks/useGlobalVariables";
import styles from "./WrongLicenceBar.module.css";
import NextLink from "next/link";
import { getCookie } from "cookies-next";
import useCheckLicenseCookie from "./hooks/useCheckLicenseCookie";
import { usePersistentStore, useStore } from "@lib/store";
import { Router } from "tabler-icons-react";
import { useRouter } from "next/router";
import HTMLRender from '@src/components/core/HTMLRender';

const Bar = ({ isSpainVisitor }) => {
  const setActiveWrongLicenseBar = usePersistentStore((state) => state.setActiveWrongLicenseBar);
  const correctLocale = getCookie("regulation_locale") || "en";
  const { gv } = useGlobalVariable();
  const contentKey = isSpainVisitor ? "forbidden_access_es_ip" : "wrong_licence_bar";

  return (
    <div
      className="wrong-licence-bar text-xs lg:text-sm force-ltr"
    >
      <div className="flex flex-col items-center justify-between bg-[#ddd] px-md py-[0.5rem] lg:flex-row lg:py-xs">
        <div
          id="wrong_licence_disclaimer"
          className={`pb-[0.3rem] text-center text-dark lg:pb-0 ${!isSpainVisitor ? 'lg:ltr:text-left rtl:lg:text-right' : 'w-full'}`}
        >
          <HTMLRender data={gv(contentKey)} />
        </div>
        {!isSpainVisitor && (
          <div id="wrong_licence_proceed_btn" className={`flex items-center ${styles.buttonProceed}`}>
            {/* <NextLink href={`/${correctLocale}`}>
              <Button label={gv("change_license_text_accept_sub")} size="sm" type="primary" />
            </NextLink> */}
            <div className="pl-md">
              <Button
                label={gv("change_license_text_decline")}
                size="sm"
                type="primary"
                onClick={() => {
                  setActiveWrongLicenseBar(false);
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const WrongLicenceBar = ({ props }) => {
  useCheckLicenseCookie();
  const router = useRouter();
  const isWrongLicence = getCookie("wrong_license") || false;
  const setActiveWrongLicenseBar = usePersistentStore((state) => state.setActiveWrongLicenseBar);
  const activeWrongLicenseBar = usePersistentStore((state) => state.activeWrongLicenseBar);
  const countryFromCookie = (getCookie("regulation_country") || "").toLowerCase();
  const normalizedCountry = typeof countryFromCookie === "string" ? countryFromCookie.toLowerCase() : "";
  const isSpainVisitor = normalizedCountry === "es";

  useEffect(() => {
    if (isWrongLicence && !activeWrongLicenseBar) {
      setActiveWrongLicenseBar(true);
    }
    if (!isWrongLicence && activeWrongLicenseBar) {
      setActiveWrongLicenseBar(false);
    }
  }, [isWrongLicence]);

  // Control body scrolling based on activeWrongLicenseBar state
  useEffect(() => {
    if (activeWrongLicenseBar) {
      // Prevent scrolling when the wrong license bar is active
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scrolling when the wrong license bar is closed
      document.body.style.overflow = '';
    }

    // Cleanup function to restore scrolling when component unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, [activeWrongLicenseBar]);

  if (!router.isReady || !activeWrongLicenseBar) {
    return null;
  }

  return (
    <>
      <div className={styles["wrong-licence-overlay"]} />
      <Bar isSpainVisitor={isSpainVisitor} />
    </>
  );
};

export default WrongLicenceBar;
